import React from "react";
import { Field } from "redux-form";
import { media } from "../../../utils/StrapiUtils";
import { IMedia } from "../../../types";
//Field трансформируется в Input(type=radio)

interface IRadioBox {
  name: string;
  value: string;
  func?: () => void;
  txt?: string;
  info?: {
    text: string;
    img?: IMedia;
  };
}
/**
 @param Name = Наименование для бекенда
 @param value = Значение переменной, которое будет записано, если нажать на кнопку(записано в бэк)
 @param func = функция, передаваемая в кнопку(это нужно для фронта по моей части)
 @param info = Информация (изображение + текст) для вопроса
 @param txt = Наименование, типо (стекло, зеркало и т.д.)
 */
export default ({ name, value, func, info, txt }: IRadioBox) => {
  const imgUrl = media(info?.img)?.src;
  return (
    <div className="calc_checker_box">
      <Field
        className="calc_checker"
        component={"input"}
        value={value}
        onClick={func}
        name={name}
        id={value}
        type={"radio"}
      />
      <label className="calc_checker_text" htmlFor={value}>
        {txt ?? value}
      </label>
      {info ? (
        <>
          <div className="calc_question">?</div>
          <div className="question_popup">
            <div className="question_popup_head">
              <div className="question_popup_head_text">{txt ?? value}</div>
            </div>
            <div className="question_popup_content">
              <div className="question_popup_content_text">{info.text}</div>
              {imgUrl && (
                <img
                  className="question_popup_content_img"
                  src={imgUrl}
                  alt={info.img?.alternativeText}
                />
              )}
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};
